// extracted by mini-css-extract-plugin
module.exports = {"container":"GuideNavigator_container__UQlNR","next":"GuideNavigator_next__sTTRT","prev":"GuideNavigator_prev__Hd2LS","shimmer":"GuideNavigator_shimmer__FinJW"};